var React = require('react');

function BgInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 387.817L173.72 170.982C181.563 178.189 191.299 183.053 201.846 185.125C234.571 191.521 266.484 169.27 273.155 135.308C277.843 111.345 268.738 87.9232 251.429 73.96L310.658 0L648 288.183L337.432 676L0 387.817Z","fill":"#F5F5FF","key":0}),React.createElement("path",{"d":"M209 169C181.938 169 160 147.062 160 120C160 92.938 181.938 71 209 71C236.062 71 258 92.938 258 120C258 147.062 236.062 169 209 169Z","fill":"#D7E0FF","key":1})]);
}

BgInline.defaultProps = {"width":"648","height":"676","viewBox":"0 0 648 676","fill":"none"};

module.exports = BgInline;

BgInline.default = BgInline;
